module.exports = __webpack_public_path__ + "img/banner.3f6d56fb.jpg";